import React from 'react'
import ReactDOM from "react-dom";


function Templatemodal({ isOpen, onClose, group, children ,heading }) {


    if (!isOpen) return null;
    return ReactDOM.createPortal(
        <div
        className="fixed top-0 left-0 w-full h-full bg-[#000000b9] flex justify-center items-center z-30">
            <div className="bg-white dark:bg-[#121519] py-3 px-5 rounded-lg shadow-lg relative w-[750px]">
                <div className='w-[100%] flex justify-between  '><span className='text-[#121519] font-semibold text-[18px] dark:text-[#fff]'>{heading}
                </span>   <button
                    className=" text-[#858484]"
                    onClick={onClose}
                >
                        ✖
                    </button>
                </div>
                {children}
            </div>
        </div>, document.getElementById("portal-root")
    )
}

export default Templatemodal
